module.exports = {
  EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST: 'EDI_RFID_AUDIT_REQUEST_CREATE_REQUEST',
  EDI_RFID_AUDIT_REQUEST_CREATE_SUCCESS: 'EDI_RFID_AUDIT_REQUEST_CREATE_SUCCESS',
  EDI_RFID_AUDIT_REQUEST_CREATE_FAILURE: 'EDI_RFID_AUDIT_REQUEST_CREATE_FAILURE',
};
